/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_EventsInputs */

const en_reference_events = /** @type {(inputs: Reference_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reference Events`)
};

const fr_reference_events = /** @type {(inputs: Reference_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Événements de référence`)
};

const de_reference_events = /** @type {(inputs: Reference_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Referenzereignisse`)
};

const it_reference_events = /** @type {(inputs: Reference_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventi di riferimento`)
};

const ru_reference_events = /** @type {(inputs: Reference_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Справочные события`)
};

const es_reference_events = /** @type {(inputs: Reference_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventos de referencia`)
};

const zh_cn2_reference_events = /** @type {(inputs: Reference_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`参考事件`)
};

const ja_reference_events = /** @type {(inputs: Reference_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`参照イベント`)
};

const hi_reference_events = /** @type {(inputs: Reference_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संदर्भ घटनाएँ`)
};

const pt_pt2_reference_events = /** @type {(inputs: Reference_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventos de referência`)
};

/**
* | output |
* | --- |
* | "Reference Events" |
*
* @param {Reference_EventsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const reference_events = /** @type {((inputs?: Reference_EventsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_EventsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_reference_events(inputs)
	if (locale === "de") return de_reference_events(inputs)
	if (locale === "it") return it_reference_events(inputs)
	if (locale === "ru") return ru_reference_events(inputs)
	if (locale === "es") return es_reference_events(inputs)
	if (locale === "zh-CN") return zh_cn2_reference_events(inputs)
	if (locale === "ja") return ja_reference_events(inputs)
	if (locale === "hi") return hi_reference_events(inputs)
	if (locale === "pt-PT") return pt_pt2_reference_events(inputs)
	return en_reference_events(inputs)
});